import { Component, OnInit } from '@angular/core';
import { InitService } from "../services/init.service";

@Component({
  selector: 'app-programacion-aventura',
  templateUrl: './programacion-aventura.component.html',
  styleUrls: ['./programacion-aventura.component.css']
})
export class ProgramacionAventuraComponent implements OnInit {

  contador: number
  constructor(private serviceInit: InitService) {
    this.serviceInit.setEstadoLayout(true);
    this.contador = 10
  }



  ngOnInit(): void {
  }



  incrementar() {
    this.contador += 1
  }


  decrementar() {
    this.contador += 1
  }
}
